import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '快速导航',
    links: [
      { label: '首页', to: '/' },
      { label: '分类浏览', to: '/category/tongren' },
      { label: '关于我们', to: '/about' },
    ],
  },
  {
    title: '热门分类',
    links: [
      { label: '日系同人漫画', to: '/category/tongren' },
      { label: '少年漫画', to: '/category/shounen' },
      { label: '少女漫画', to: '/category/shoujo' },
    ],
  },
  {
    title: '创作资源',
    links: [
      { label: '漫画创作教程', to: '/category/tutorial' },
      { label: '原创漫画', to: '/category/original' },
      { label: '青年漫画', to: '/category/seinen' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-bold text-sm">翼</span>
              <span className="text-lg font-bold text-foreground-950 whitespace-nowrap">无翼鸟漫画</span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              致力于为漫画爱好者提供优质的漫画资源导航、阅读推荐与创作指南。发现好漫画，从这里开始。
            </p>
          </div>
          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold text-foreground-950 mb-4">{group.title}</h4>
              <ul className="flex flex-col gap-2">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 无翼鸟漫画 版权所有 | 本站为漫画资源导航与阅读指南网站
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-500 hover:text-primary-500 transition-colors" aria-label="微博">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#" className="text-foreground-500 hover:text-primary-500 transition-colors" aria-label="微信">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" className="text-foreground-500 hover:text-primary-500 transition-colors" aria-label="RSS">
              <i className="ri-rss-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}